<template>
  <div class="flex justify-between mb-12">
    <div class="h-5 bg-gray-200 rounded-full dark:bg-gray-700 w-36 md:w-72" />
    <div class="h-3 bg-gray-200 rounded-full dark:bg-gray-700 w-24 md:w-48" />
  </div>
</template>
